import { render, staticRenderFns } from "./CollectionScreen.vue?vue&type=template&id=5fa65585&"
import script from "./CollectionScreen.vue?vue&type=script&lang=js&"
export * from "./CollectionScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports